/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriod_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBookingS = $resource(baseUrl + 'rest/workingPeriods/:id',{}, {});
        return resourceBookingS;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('WorkingPeriod',["$log","$locale","DateSrv","WorkingPeriodData","WorkingPeriod_Resource","WorkingPeriodDay","Period",
        function ($log,$locale,DateSrv,WorkingPeriodData,WorkingPeriod_Resource,WorkingPeriodDay,Period)
        {
    //Booking inherit of Booking_Resource

    var  WorkingPeriod = function (workingPeriodRes,site, isApplicationLoading)
    {
        this.id = null;
        this.site = null;
        this.period = null;
        this.workingPeriodDays = [];//mondayToSunday active value

        WorkingPeriodData.add(this);

        if (site!==undefined && site!=null)
            this.site = site;

        if (workingPeriodRes!==undefined && workingPeriodRes!=null)
        {
            if (!this.id)
                this.id = workingPeriodRes.id;
            this.period = new Period(workingPeriodRes.period);
            // set the duration time
            if (workingPeriodRes.workingPeriodDays)
                for (var i=0;i<workingPeriodRes.workingPeriodDays.length;i++)
                    this.workingPeriodDays.push(new WorkingPeriodDay(workingPeriodRes.workingPeriodDays[i],this, isApplicationLoading));

        }

    }
    WorkingPeriod.prototype.getObjectResource = function()
    {
        var workingPeriodRes = new WorkingPeriod_Resource();
        workingPeriodRes.id = this.id;
        if (this.site)
            workingPeriodRes.siteId = this.site.id;
        workingPeriodRes.period = this.period.getObjectResource();
        workingPeriodRes.workingPeriodDays=[];
        for (var i=0;i<this.workingPeriodDays.length;i++)
            workingPeriodRes.workingPeriodDays.push(this.workingPeriodDays[i].getObjectResource());

        return workingPeriodRes;
    }
    WorkingPeriod.prototype.addWorkingPeriodDay = function(workingPeriodDay)
    {
        this.workingPeriodDays.push(workingPeriodDay);
        workingPeriodDay.workingPeriod = this;
        return this.workingPeriodDays.length -1;

    }
    WorkingPeriod.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
    }
    WorkingPeriod.prototype.setId = function(id)
    {
        this.id = id;
    }
    WorkingPeriod.prototype.getId = function()
    {
        return this.id;
    }
    WorkingPeriod.prototype.isOpenWorkingPeriodForHr= function(dayOfWIndex,hrId,period)
    {
        var wperiod = this.getPeriodOfWorkForHr(dayOfWIndex,hrId);
        $log.error("depracated")
        if (wperiod)
        {
            return ((period.start.hour *60 + period.start.minute)<
            (wperiod.end.hour *60 + wperiod.end.minute)) &&
            ((period.end.hour *60 + period.end.minute)>
            (wperiod.start.hour *60 + wperiod.start.minute));
        }

        return false;
    }
    WorkingPeriod.prototype.isOpenWorkingPeriodForPr= function(dayOfWIndex,prId,prUnitId,period)
    {
        var wperiod = this.getPeriodOfWorkForPr(dayOfWIndex,prId,prUnitId);
        $log.error("depracated")
        if (wperiod)
        {
            return ((period.start.hour *60 + period.start.minute)<
                (wperiod.end.hour *60 + wperiod.end.minute)) &&
                ((period.end.hour *60 + period.end.minute)>
                    (wperiod.start.hour *60 + wperiod.start.minute));
        }

        return false;
    }
    WorkingPeriod.prototype.getWpDay = function(dayOfWIndex)
    {
        if (this.workingPeriodDays[dayOfWIndex])
            return this.workingPeriodDays[dayOfWIndex];
    };

    WorkingPeriod.prototype.getPeriodOfWorkForHr= function(dayOfWIndex,hrId)
    {
        // return periods of work according : dayOfWIndex + Hrid
        var period = null;
        if (this.workingPeriodDays[dayOfWIndex] && this.workingPeriodDays[dayOfWIndex].openDay)
        {
            period = this.period;
            var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayHr(hrId);
            if (wpDayHr && wpDayHr.specificPeriod)
                period = wpDayHr.period;
        }
        return period;
    }
    WorkingPeriod.prototype.getPeriodOfWorkForPr= function(dayOfWIndex,prId,prUnitId)
    {
        // return periods of work according : dayOfWIndex + Hrid
        var period = null;
        if (this.workingPeriodDays[dayOfWIndex] && this.workingPeriodDays[dayOfWIndex].openDay)
        {
            period = this.period;
            var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayPr(prId,prUnitId);
            if (wpDayHr && wpDayHr.specificPeriod)
                period = wpDayHr.period;
        }
        return period;
    }

    WorkingPeriod.prototype.getDefaultPeriodOfWork= function(dayOfWIndex,hrId)
    {
        // return default periods of work according : dayOfWIndex + Hrid
        // if day closed get period of WP
        var period  = null;
        if (this.workingPeriodDays[dayOfWIndex].openDay)
            period = this.period;
        var wpDayHr = this.workingPeriodDays[dayOfWIndex].getWorkingPeriodDayHr(hrId);
        if (wpDayHr && wpDayHr.specificPeriod &&  wpDayHr.period)//period cant be null
            period = wpDayHr.period;

        return period;
    }
    WorkingPeriod.prototype.setHumanResource = function(humanResource)
    {
        //if (this.humanResource!=null && this.humanResource!= humanResource)
            //this.humanResource.removeWorkingPeriod(this);
        this.humanResource = humanResource;
        if (this.humanResource!=null)
        {
//            this.humanResource.addWorkingPeriod(this);
        }

    }
    WorkingPeriod.prototype.getHumanResource = function()
    {
        return this.humanResource;

    }
    WorkingPeriod.prototype.setPhysicalResource = function(physicalResource)
    {
//        if (this._physicalResource!=null && this._physicalResource!= physicalResource)
//            this._physicalResource.removeWorkingPeriod(this);
        this._physicalResource = physicalResource;
        if (this._physicalResource!=null)
        {
            this.physicalResourceId =  this._physicalResource.getId();
//            this._physicalResource.addWorkingPeriod(this);
        }


    }
    WorkingPeriod.prototype.setInherit = function(inherit)
    {
        this.inherit=inherit;
    }

     return WorkingPeriod;
}
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodSrv',["$log","WorkingPeriod_Resource","SiteData","ServerSrv",
        function ($log,WorkingPeriod_Resource,SiteData,ServerSrv)
        {
        var  workingPeriodSrv = {};

        workingPeriodSrv.save =  function(workingPeriod,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(workingPeriodSrv.saveSync, workingPeriod, successFunction, errorFunction);
        };
        workingPeriodSrv.saveSync =  function(workingPeriod,successFunction,errorFunction)
        {
            //$timeout (function () {

            var workingPeriodRes = workingPeriod.getObjectResource();
            workingPeriodRes.$save({}, //no params
                function (data) {
                    try{
                        /** @namespace data.workingPeriodDaysId */
                        workingPeriod.setId(data.id);

                        if (data.workingPeriodDaysId && data.workingPeriodDaysId.length==workingPeriod.workingPeriodDays.length)
                        //Assume that returned list has the same order
                            for (var i=0;i< data.workingPeriodDaysId.length;i++)
                                workingPeriod.workingPeriodDays[i].setId(data.workingPeriodDaysId[i]);
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        workingPeriodSrv.remove =  function(workingPeriod,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(workingPeriodSrv.removeSync, workingPeriod, successFunction, errorFunction);
        };
        workingPeriodSrv.removeSync =  function(workingPeriod,successFunction,errorFunction)
        {
            //$timeout (function () {

            var workingPeriodRes = new WorkingPeriod_Resource();
            workingPeriodRes.$remove({id:workingPeriod.id}, //no params
                function (data) {
                    SiteData.removeWorkingPeriod(workingPeriod);

                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        workingPeriodSrv.updateLocally =  function(id,objectToRestore)
        {
/*            var day =  DayData.get(objectToRestore.dayId)
            if (day!=null)
            {
                var workingPeriod = day.getWorkingPeriod(objectToRestore.id)
                workingPeriod.loadObject(objectToRestore);
                workingPeriod.loadRef();
            }*/
        };

        return workingPeriodSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodData',[ function ()
    {
        var  workingPeriodData =
        {
            indexWorkingPeriods : []
        };
        workingPeriodData.getById =  function(workingPeriodId)
        {
            for (var i=0;i<this.indexWorkingPeriods.length;i++)
                if (this.indexWorkingPeriods[i].id==workingPeriodId)
                    return this.indexWorkingPeriods[i];
            return null;
        }
        workingPeriodData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexWorkingPeriods.length)
                return this.indexWorkingPeriods[servIndex];
            else
                return null;
        }
        workingPeriodData.getIndexOf =  function(workingPeriod)
        {
            if (workingPeriod)
                return this.indexWorkingPeriods.indexOf(workingPeriod);
            return -1;
        }
        workingPeriodData.add =  function(workingPeriod)
        {
            this.indexWorkingPeriods.push(workingPeriod);
            return this.indexWorkingPeriods.length-1;
        }
        workingPeriodData.clear =  function()
        {
            workingPeriodData.indexWorkingPeriods = [];
        }
        return workingPeriodData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/WorkingPeriod.js